// Redux
import { useSelector } from "react-redux";

// Custom Hooks
import useNavigation from "../hooks/useNavigation";

// Components
import CommonNavigation from "../CommonNavigation";

// Styles
import "../styles.css";

function LoyacStaffOptions() {
  const user = useSelector((state: any) => state.rootAuth.user);

  const { loyacStaff, tempEvents } = useNavigation();

  return (
    <CommonNavigation
      data={user.email === "ushervolunteer@loyac.org" ? tempEvents : loyacStaff}
    />
  );
}

export default LoyacStaffOptions;
